import Api from '../../../common/services/api';

export default (token) => () => Api
  .post('/v1/password/reset/confirm', { token }, false);
